import { Box } from '@coolblue-development/freddy';
import showAccessoryProductsTrigger from '@coolblue-development/ga4-events/triggers/RecommendedAccessories/showAccessoryProductsTrigger';
import viewTrigger from '@coolblue-development/ga4-events/triggers/RecommendedAccessories/viewTrigger';
import { TrackImmediate, TrackWhenVisible } from '@coolblue-development/next-analytics/client';
import { ProductCardSectionContent } from '@features/add-to-cart-page/components/Sections/ProductCardSectionContent';
import SectionTitle from '@features/add-to-cart-page/components/SectionTitle/SectionTitle';
import { ATCPageAutomatedSection } from '@features/add-to-cart-page/typings/AutomatedSection';
import { getAddToCartPageType } from '@features/add-to-cart-page/utils/getAddToCartPageType';
import useTestId from '@hooks/useTestId';
import { useTranslation } from '@i18n/useTranslation';

import { AddToCartPageSectionProps } from '../../typings/AddToCartPageSection';
import { useCustomerContext } from './CustomerContext/CustomerContext';

export function AutomatedSection({
  product,
  section,
  order,
  shouldUsePromotionalContent
}: AddToCartPageSectionProps) {
  const { t } = useTranslation('webshop.addToCart.automatedSection');
  const testId = useTestId('automated-section');
  const { isBusinessCustomer } = useCustomerContext();
  const addToCartPageType = getAddToCartPageType({ isBusiness: isBusinessCustomer });
  const automatedSection = section as ATCPageAutomatedSection;

  const title = automatedSection.title ? automatedSection.title : t('defaultTitle');

  const attachedItemIds = automatedSection.slots
    .map(slot => slot.slotProduct.id.toString())
    .join(',');

  const viewParams: Parameters<typeof viewTrigger>[0] = {
    item_ids: attachedItemIds,
    has_highlighted_segment: false
  };

  const showAccessoryProductsParams: {
    primary_item_id: number;
    attached_item_ids: string;
    sub_feature: string | null;
  } = {
    primary_item_id: product.id,
    attached_item_ids: attachedItemIds,
    sub_feature: addToCartPageType
  };

  return (
    <Box {...testId} mt={800} component='section'>
      <TrackImmediate trigger={showAccessoryProductsTrigger(showAccessoryProductsParams)} />
      {title && <SectionTitle title={title} index={order} />}
      <TrackWhenVisible trigger={viewTrigger(viewParams)}>
        <ProductCardSectionContent
          section={automatedSection}
          mainProductId={product.id}
          isAutomated
          shouldUsePromotionalContent={shouldUsePromotionalContent}
        />
      </TrackWhenVisible>
    </Box>
  );
}
